import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeCustomProp, makeArrayProp, makeNumericProp, makeStringProp } from '@/utils';
import {
  DropdownMenu,
  DropdownItem,
  Search,
  type DropdownItemOption as VanDropdownItemOption,
  type SearchProps as VanSearchProps,
  Icon,
} from 'vant';
import { t } from '@/assets/theme';

const { name, bem } = createNamespaceBem('search');

const searchProps = {
  withCate: makeCustomProp<boolean>(Boolean, true),
  cate: makeNumericProp(0),
  keyword: makeStringProp(''),
  options: makeArrayProp<VanDropdownItemOption>(),
  placeholder: makeCustomProp<VanSearchProps['placeholder']>(String, '搜索机构名称'),
  leftIcon: makeCustomProp<VanSearchProps['leftIcon']>(String, 'search'),
  classPrefix: String,
};

export type SearchProps = ExtractPropTypes<typeof searchProps>;

export default defineComponent({
  name,

  props: searchProps,

  emits: ['update:keyword', 'update:cate', 'do-search'],

  setup(props, { emit }) {
    const kw = ref(props.keyword);
    const onChangeCate = (value) => {
      emit('update:cate', value);
      emit('update:keyword', kw.value);
      emit('do-search', kw.value);
    };
    const onSearch = (value) => {
      emit('update:keyword', value);
      emit('do-search', kw.value);
    };
    const renderLeftIcon = () => {
      return <Icon classPrefix={props.classPrefix} name={props.leftIcon} size={t(16)} />;
    };

    return () => (
      <div class={bem()}>
        <div class={bem('wrap')}>
          {props.withCate && (
            <>
              <DropdownMenu class={bem('cate')}>
                <DropdownItem v-model={props.cate} onChange={onChangeCate} options={props.options} />
              </DropdownMenu>
              <div class={bem('line')}></div>
            </>
          )}
          <Search
            // 曲线救国：使用props.keyword直接绑定时，一直报只读
            v-model={kw.value}
            // v-model={props.keyword}
            class={bem('search')}
            placeholder={props.placeholder}
            v-slots={{ 'left-icon': renderLeftIcon }}
            onSearch={onSearch}
          />
        </div>
      </div>
    );
  },
});
